import { useCanvasFileRecords } from "@/api/fileRecords";
import { buildFileRecordLookups } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/canvas/canvasRailContentsModel";
import { useCanvasNodesMirrorState } from "@/pages/canvas/context/CanvasNodesMirrorContext";
import type { FileRecord } from "@cohesive/api-client";
import { useMemo } from "react";

const EMPTY_RECORDS: FileRecord[] = [];
const EMPTY_MAP = new Map<string, string>();

/**
 * The open canvas's file rows and the node each placed row renders as, keyed
 * by row id (a reference resolves through its link row, see
 * buildFileRecordLookups). Empty without a canvas — surfaces that can open on
 * any route (the detail pane, node menus) get no node to act on.
 */
export function useCanvasFileRecordNodeIds(canvasId: string | undefined) {
  const { data: fileRecords = EMPTY_RECORDS } = useCanvasFileRecords(canvasId);
  const { nodes: rawNodes } = useCanvasNodesMirrorState(canvasId ?? "");

  const fileRecordIdToNodeId = useMemo(() => {
    if (!canvasId) return EMPTY_MAP;
    return buildFileRecordLookups(fileRecords, rawNodes).fileRecordIdToNodeId;
  }, [canvasId, fileRecords, rawNodes]);

  return { fileRecords, rawNodes, fileRecordIdToNodeId };
}
